/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Inspired by https://stackoverflow.com/a/22482737
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var isObject = function isObject(value) {
  return Object(value) === value;
};
export default isObject;